import * as React from 'react';

import {view, Link} from '@sail/ui';
import {FormattedMessage, defineMessages} from 'react-intl';
import {
  Conversation,
  InlineDataConversationMessage,
} from '@stripe-internal/conversations-client';
import {useAnalytics} from '../AnalyticsProvider';
import {useAssistantAnalyticsCall} from '../StripeAssistant/analytics-utils';

const messages = defineMessages({
  visitSupportMessage: {
    id: 'conversations_ui.visit_support_message',
    description: 'Message to tell the user to visit our support site.',
    defaultMessage:
      "It seems like you're looking for support. Visit {link} to find help articles or contact a support agent.",
  },
});

type Props = {
  conversation: Conversation;
  message: InlineDataConversationMessage;
};

export const SupportSiteEscalation = ({conversation, message}: Props) => {
  const analytics = useAnalytics();

  useAssistantAnalyticsCall(conversation, message, () => {
    analytics.action('ai_assistant_agent_escalation_created');
  });

  return (
    <view.div>
      <FormattedMessage
        {...messages.visitSupportMessage}
        values={{
          link: (
            <Link href="https://support.stripe.com" target="_blank">
              support.stripe.com
            </Link>
          ),
        }}
      />
    </view.div>
  );
};
